import React from "react";

export default function Loading({ overlay, description }) {
	return (
		<div className={`loading ${overlay ? "overlay" : ""}`}>
			<div className="loading-logo">
				<div className="dot"></div>
				<div className="dot"></div>
				<div className="dot"></div>
			</div>
			<>{description ? <p className="loading-description">{description}</p> : null}</>
		</div>
	);
}
